import { atom } from 'jotai'
import { atomFamily, atomWithStorage } from 'jotai/utils'

export type DispatchBoardDisplayMode = 'name' | 'address'

const DEFAULT_DISPLAY_MODE: DispatchBoardDisplayMode = 'name'

const getDisplayModeStorageKey = (userId: number) =>
  `dispatch-board-display-mode:${String(userId)}`

type Params = { userId: number }

/**
 * 配車板の表示モードAtom（ユーザー単位）
 * - 'name': 地点名表示（短表示 > 中表示 > 正式名称のフォールバック）
 * - 'address': 住所表示
 * - localStorage で永続化
 */
export const dispatchBoardDisplayModeAtomFamily = atomFamily(
  (params: Params) => {
    const storageKey = getDisplayModeStorageKey(params.userId)

    const base = atomWithStorage<DispatchBoardDisplayMode>(
      storageKey,
      DEFAULT_DISPLAY_MODE
    )

    return atom(
      (get) => get(base),
      (_get, set, next: DispatchBoardDisplayMode) => set(base, next)
    )
  },
  (a, b) => a.userId === b.userId
)
